import React from 'react';

var classNames = require('classnames');

function QED(props) {

    return (
        <table className='table  table-responsive table-hover' style={{cursor:'default'}} {...props} >
            {props.children}
        </table>
    );
}


QED.Columns = function(props) {


    let renderColumn = (column, index) => {
        let {sort, html, ...props} = column;

        if (typeof html == 'function')
            html = html(index);


        return (
            <th key={index} column={index} {...props}>
                {html}
            </th>
        );
    }

    let renderColumns = (columns) => {

        if (columns == undefined)
            return props.children;

        return columns.map((column, index) => {
            return renderColumn(column, index);
        });
    }

    var {columns, ...props} = props;

    return (
        <thead>
            <tr {...props}>
                {renderColumns(columns)}
            </tr>
        </thead>
    );
}



QED.Rows = function(props) {

    var {rows, ...props} = props;

    let renderCell = (cell, rowIndex, columnIndex) => {
        let {html, ...props} = cell;

        if (typeof html == 'function')
            html = html(rowIndex, columnIndex);

        return (
            <td key={columnIndex} row={rowIndex} column={columnIndex} {...props}>
                {html}
            </td>
        );
    }

    let renderRow = (row, rowIndex) => {

        let html = row.map((cell, columnIndex) => {
            return renderCell(cell, rowIndex, columnIndex);
        });

        return (
            <tr key={rowIndex} row={rowIndex}>
                {html}
            </tr>
        );
    };

    let html = rows.map((row, rowIndex) => {
        return renderRow(row, rowIndex);
    });


    return (
        <tbody {...props}>
            {html}
        </tbody>
    );

}



export default QED;